import { useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/shared/Header";
import { Button } from "../../components/ui/button";
import { ParticipantsFields } from "../../components/expenses/ExpenseFormFields";
import { useEvents } from "../../context/EventContext";
import { useExpenseForm } from "../../context/ExpenseFormContext";

export function ExpenseStepParticipants() {
  const { eventId, expenseId } = useParams<{
    eventId: string;
    expenseId?: string;
  }>();
  const navigate = useNavigate();
  const { currentEvent, addExpense, updateExpense } = useEvents();
  const {
    description,
    amount,
    paidById,
    participantIds,
    setParticipantIds,
    isInitialized,
  } = useExpenseForm();

  // Default selection to all participants on first mount if empty.
  useEffect(() => {
    if (!currentEvent) return;
    if (participantIds.length === 0) {
      setParticipantIds(currentEvent.participants.map((p) => p.id));
    }
  }, [currentEvent, participantIds.length, setParticipantIds]);

  if (!currentEvent) return null;

  const parentRoute = `/event/${eventId}/expenses`;
  const isEdit = Boolean(expenseId);
  const title = isEdit ? "Editar gasto" : "Nuevo gasto";

  // If the user landed on step-2 directly (refresh), context is empty → bounce to step-1.
  if (!isInitialized) {
    return <Navigate to="../step-1" replace />;
  }

  const isValid = participantIds.length > 0;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValid) return;
    if (isEdit && expenseId) {
      updateExpense(expenseId, {
        description: description.trim(),
        amount,
        paidById,
        participantIds,
      });
    } else {
      addExpense(description.trim(), amount, paidById, participantIds);
    }
    navigate(parentRoute);
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header
        title={title}
        onBack={() => navigate(-1)}
        variant="prominent"
      />
      <main className="flex-1 px-4 pt-4 pb-[calc(1rem+env(safe-area-inset-bottom))]">
        <form onSubmit={handleSubmit} className="space-y-4">
          <p className="text-sm text-muted-foreground">Paso 2 de 2</p>

          <ParticipantsFields
            participants={currentEvent.participants}
            selectedIds={participantIds}
            onChange={setParticipantIds}
          />

          {!isValid && (
            <p className="text-sm text-muted-foreground">
              Selecciona al menos un participante
            </p>
          )}

          <div className="flex gap-2 pt-2">
            <Button
              type="button"
              variant="outline"
              onClick={() => navigate(-1)}
              className="flex-1"
            >
              Atrás
            </Button>
            <Button type="submit" disabled={!isValid} className="flex-1">
              {isEdit ? "Guardar cambios" : "Agregar gasto"}
            </Button>
          </div>
        </form>
      </main>
    </div>
  );
}
